import { render, staticRenderFns } from "./GapsIdentificationTool.vue?vue&type=template&id=f3b95856&scoped=true"
import script from "./GapsIdentificationTool.vue?vue&type=script&lang=js"
export * from "./GapsIdentificationTool.vue?vue&type=script&lang=js"
import style0 from "./GapsIdentificationTool.vue?vue&type=style&index=0&id=f3b95856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b95856",
  null
  
)

export default component.exports